var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___SHlfTk",
  "uW": "GuildNotificationSettingsModal.module__section___SHlfTk",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___SHlfTk",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___SHlfTk",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___SHlfTk",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___SHlfTk",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___SHlfTk",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___SHlfTk",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___SHlfTk",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___SHlfTk",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___SHlfTk",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___SHlfTk",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___SHlfTk",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___SHlfTk",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___SHlfTk",
  "p": "GuildNotificationSettingsModal.module__channelIcon___SHlfTk",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___SHlfTk",
  "HA": "GuildNotificationSettingsModal.module__channelName___SHlfTk",
  "yb": "GuildNotificationSettingsModal.module__categoryName___SHlfTk",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___SHlfTk",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___SHlfTk",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___SHlfTk",
  "DT": "GuildNotificationSettingsModal.module__removeButton___SHlfTk",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___SHlfTk",
};

module.exports = exports;
